"use client";

import React from "react";
import { LargePageTitleText, BodyText } from "src/components/owlet-typography";
import { OwletActionButton } from "src/components/owlet-action-button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-[#060727]">
      <div className="text-center">
        <LargePageTitleText className="mb-4">
          Something went wrong!
        </LargePageTitleText>
        <BodyText className="mb-8">{error.message}</BodyText>
        <OwletActionButton
          text="Try again"
          type="button"
          variant="primary"
          onClick={reset}
        />
      </div>
    </div>
  );
}
